module.exports = __webpack_public_path__ + "img/package.45374aef.png";